import { render, staticRenderFns } from "./LoyaltyCoupons.vue?vue&type=template&id=021d26fb&scoped=true&lang=pug&"
import script from "./LoyaltyCoupons.vue?vue&type=script&lang=js&"
export * from "./LoyaltyCoupons.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyCoupons.vue?vue&type=style&index=0&id=021d26fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d26fb",
  null
  
)

export default component.exports